import axios from 'axios';

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/agreements";


// ALL THE GET's
// Function to get all agreements for users
/* export async function getAllAgreementsForUsers(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-agreements-for-user`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreements');
  }
} */

// Function to get all agreements for a user
export const getAgreementsForUser = async (apiAccessToken) => {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-agreements-for-user`, { // Corrected endpoint URL
      headers: {
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreements');
  }
};

// Function to get a specific agreement by agreementId
export async function getAgreementByPublicId(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-agreement-by-public-id/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement');
  }
}

// Function to get contactperson by agreementId
export async function getContactPersonForAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/ContactPerson/get-contact-person-for-agreement/${agreementPublicId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Request failed:", error.response?.data || error);
    throw new Error(error.response?.data?.message || 'Failed to fetch contact person');
  }
} 

// ALL THE POST's
// Function to create a new agreement
export async function createAgreement(agreementData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/Agreements/create-agreement`, agreementData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to create agreement');
  }
}


// ALL THE PUT's
// Function to update an existing agreement
export async function updateAgreement(agreementData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/Agreements/update-agreement`, agreementData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to update agreement');
  }
}


// ALL THE DELETE's
// Function to delete an agreement by agreementId
export async function deleteAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/Agreements/delete-agreement/${agreementPublicId}`, {
      headers: {
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete agreement');
  }
}

export async function getAllAgreementServicesforAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-agreement-services-for-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

export async function getAccountTypesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AccountType/get-account-types-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch account types by agreement');
  }
}

export async function getUserDevicesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-user-devices-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user devices by agreement');
  }
}

export async function getUserProgramsByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-user-programs-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user programs');
  }
}

// DOMAINS
export async function getDomains(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Domain/get-domains-by-agreement-public-id-dip/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch domains');
  }
} 